module.exports = __webpack_public_path__ + "img/icon-same-store-auto.36985fd2.svg";